import StreetView from './ol-street-view';

import * as methods from './ol-street-view';
Object.assign(StreetView, methods);

export default StreetView;
